export default "__VITE_ASSET__5e375319__"